webpackJsonp([263791100135453],{

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.OutboundLink = undefined;
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OutboundLink(props) {
	  return _react2.default.createElement("a", (0, _extends3.default)({}, props, {
	    onClick: function onClick(e) {
	      if (typeof props.onClick === "function") {
	        props.onClick();
	      }
	      var redirect = true;
	      if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.defaultPrevented) {
	        redirect = false;
	      }
	      if (props.target && props.target.toLowerCase() !== "_self") {
	        redirect = false;
	      }
	      if (window.ga) {
	        window.ga("send", "event", {
	          eventCategory: "Outbound Link",
	          eventAction: "click",
	          eventLabel: props.href,
	          transport: redirect ? "beacon" : "",
	          hitCallback: function hitCallback() {
	            if (redirect) {
	              document.location = props.href;
	            }
	          }
	        });
	      } else {
	        if (redirect) {
	          document.location = props.href;
	        }
	      }
	
	      return false;
	    }
	  }));
	}
	
	OutboundLink.propTypes = {
	  href: _propTypes2.default.string,
	  target: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	
	exports.OutboundLink = OutboundLink;

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(139);
	
	var _semanticUiReact = __webpack_require__(35);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage() {
	  return _react2.default.createElement(
	    'div',
	    { style: { maxWidth: 1260, margin: '0 auto' } },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'About | Find Growth Tools'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'A curated list of the best SaaS growth tools.' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { basic: true },
	      _react2.default.createElement(
	        _semanticUiReact.Breadcrumb,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Breadcrumb.Section,
	          { link: true },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', style: { color: '#dcddde' } },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'angle left' }),
	            'Home'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'h1',
	      {
	        style: {
	          fontSize: '3.25rem',
	          color: '#fff'
	        }
	      },
	      'About'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'div',
	      { style: { maxWidth: 960, margin: '0 auto' } },
	      _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { style: { padding: '40px' } },
	        _react2.default.createElement(
	          'h2',
	          { style: { textAlign: 'center' } },
	          'A curated list of the best SaaS software to help companies grow.'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          { style: { fontSize: '1.25em', textAlign: 'center' } },
	          'FindGrowthTools is made by ',
	          _react2.default.createElement(
	            _gatsbyPluginGoogleAnalytics.OutboundLink,
	            { href: 'https://twitter.com/_davidturnbull', target: '_blank' },
	            'David Turnbull'
	          ),
	          ', a growth marketer based in Stockholm, Sweden.',
	          _react2.default.createElement('br', null),
	          ' ',
	          _react2.default.createElement('br', null),
	          'Rather than listing every product within a category, Find Growth Tools aims to provide a selection of the best tools used or recommended by David and his friends and collegaues.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'em',
	            null,
	            'Know a great growth tool that\'s missing from the site? ',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/suggest' },
	              'Make a suggestion!'
	            )
	          ),
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Tech Stack'
	          ),
	          'The site has been built using ',
	          _react2.default.createElement(
	            _gatsbyPluginGoogleAnalytics.OutboundLink,
	            { href: 'https://www.gatsbyjs.org/', target: '_blank' },
	            'GatsbyJS'
	          ),
	          ', ',
	          _react2.default.createElement(
	            _gatsbyPluginGoogleAnalytics.OutboundLink,
	            { href: 'https://www.netlify.com/', target: '_blank' },
	            'Netlify'
	          ),
	          ' and ',
	          _react2.default.createElement(
	            _gatsbyPluginGoogleAnalytics.OutboundLink,
	            { href: 'https://www.contentful.com/', target: '_blank' },
	            'Contentful'
	          ),
	          '.'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    )
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-9280955f44d846004f12.js